import { HTMLInputTypeAttribute, ReactNode, useState } from "react";
import IconEye from "../../../components/icons/icon-eye";
import IconLockDots from "../../../components/icons/icon-lock-dots";

interface NewPasswordComponentProps {
  requestNewPassword: (value: string) => void;
  isLoading: boolean;
}

export const NewPasswordComponent = ({
  requestNewPassword,
  isLoading,
}: NewPasswordComponentProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [showErrorPassword, setShowErrorPassword] = useState(false);
  const [showErrorRePassword, setShowErrorRePassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [reNewPassword, setReNewPassword] = useState("");
  const [errorNewPassword, setErrorNewPassword] = useState("");
  const [errorReNewPassword, setErrorReNewPassword] = useState("");

  interface InputProps {
    labelText: string;
    type: HTMLInputTypeAttribute;
    icon: ReactNode;
    autoFocus?: boolean;
  }

  interface StateProps {
    isShow: boolean;
    value: string;
    setShowPassword: () => void;
    setValue: (value: string) => void;
  }

  interface ErrorProps {
    isShowError: boolean;
    messageError: string;
  }

  function renderComponent(
    { labelText, type, icon, autoFocus = false }: InputProps,
    { isShow, value, setShowPassword, setValue }: StateProps,
    { isShowError, messageError }: ErrorProps
  ) {
    return (
      <div>
        <label
          htmlFor="labelText"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          {labelText}
        </label>
        <div className="relative">
          <span className="absolute -translate-y-1/2 start-4 top-1/2">
            {icon}
          </span>
          <input
            autoFocus={autoFocus}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setValue(e.target.value)
            }
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
              e.key === "Enter" && handleChangeNewPassword()
            }
            type={type}
            placeholder="Nhập thông tin"
            className="form-input ps-10 placeholder:text-white-dark"
          />
          <button
            type="button"
            className="absolute -translate-y-1/2 end-4 top-1/2"
            data-testid="toggle-new-password-visibility"
            onClick={setShowPassword}
          >
            <IconEye isIconOff={isShow} />
          </button>
        </div>
        {isShowError && (
          <span className="text-sm text-red-500">{messageError}</span>
        )}
      </div>
    );
  }

  const handleChangeNewPassword = () => {
    if (!validateNewPassword()) {
      return;
    }
    requestNewPassword(newPassword);
  };

  const validateNewPassword = () => {
    if (newPassword.length < 2) {
      setShowErrorPassword(true);
      setErrorNewPassword("Mật khẩu phải lớn hơn 2 kí tự");
      return false;
    }
    if (newPassword.length > 20) {
      setShowErrorPassword(true);
      setErrorNewPassword("Mật khẩu tối đa 20 kí tự");
      return false;
    }

    if (reNewPassword.length > 20) {
      setShowErrorRePassword(true);
      setErrorReNewPassword("Mật khẩu tối đa 20 kí tự");
      return false;
    }
    if (reNewPassword.length < 2) {
      setShowErrorRePassword(true);
      setErrorReNewPassword("Mật khẩu phải lớn hơn 2 kí tự");
      return false;
    }

    if (newPassword !== reNewPassword) {
      setShowErrorRePassword(true);
      setErrorReNewPassword("Mật khẩu nhập lại không giống nhau");
      return false;
    }
    return true;
  };

  return (
    <form className="space-y-5" data-testid="verify-otp-form">
      {renderComponent(
        { labelText: "Mật khẩu mới", type: showPassword ? "text" : "password", icon: <IconLockDots fill={false} />, autoFocus: true },
        { isShow: showPassword, value: newPassword, setShowPassword: () => setShowPassword(!showPassword), setValue: setNewPassword },
        { isShowError: showErrorPassword, messageError: errorNewPassword }
      )}

      {renderComponent(
        { labelText: "Nhập lại mật khẩu mới", type: showRePassword ? "text" : "password", icon: <IconLockDots fill={false} /> },
        { isShow: showRePassword, value: reNewPassword, setShowPassword: () => setShowRePassword(!showRePassword), setValue: setReNewPassword },
        { isShowError: showErrorRePassword, messageError: errorReNewPassword }
      )}

      <button
        type="button"
        className="btn btn-gradient w-full border-0 shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]"
        onClick={handleChangeNewPassword}
        disabled={isLoading}
        data-testid="new-password-button"
      >
        {isLoading && (
          <span className="inline-block w-5 h-5 align-middle border-2 border-white rounded-full animate-spin border-l-transparent ltr:mr-4 rtl:ml-4"></span>
        )}
        ĐỔI MẬT KHẨU
      </button>
    </form>
  );
};
